import React from 'react';
import './css/Client.css';
import futureimage from "../assets/futurebg.png";
import table from "../assets/table1.png";

const Clients = () => {
    return (
        <section className='main-div2'>
            <div className='client-main-div2-content1'>
                <div className='client-main-div2-content1-content1-image'>
                    <img src={futureimage} alt="Dhiman Wood Works Project"/>
                </div>
                <div className='client-main-div2-content1-content2'>
                    <h1 className='client-main-div2-content1-content2-heading'>Client Success Stories</h1>
                    <div className='client-main-div2-content1-content2-content2'>
                        <div className='client-main-div2-content1-content2-content2-content1-images'>
                            <div className='client-image-div'>
                                <img src={table} alt="Custom Wooden Furniture"/>
                            </div>
                            <div className='client-image-div'>''</div>
                        </div>
                        <div className='client-main-div2-content1-content2-content2-content2-images-content'>
                            <h1 className='client-main-div2-content1-content2-content2-content2-images-content-heading'>
                                Rajesh Sharma
                            </h1>
                            <p className='client-main-div2-content1-content2-content2-content2-images-content-paragraph'>
                                Complete Office Interior Woodwork
                            </p>
                        </div>
                    </div>
                    <div className='client-main-div2-content1-content2-content3'>
                        <h1 className='client-main-div2-content1-content2-content3-heading'>
                            Exceptional craftsmanship and attention to detail by Babu Ram Dhiman
                        </h1>
                        <p className='client-main-div2-content1-content2-content3-paragraph'>
                            The woodwork in our office has transformed the entire space. The custom cabinets and furniture pieces showcase incredible craftsmanship. Dhiman Wood Works delivered beyond our expectations, combining traditional techniques with modern design perfectly.
                        </p>
                    </div>
                    <div className='map-ring'>
                        {[1, 2, 3, 4, 5, 6].map((item, index) => (
                            <div 
                                style={{
                                    borderColor: index==0 && "#111",
                                    zIndex: index==0 && "2"
                                }} 
                                className='ring-style' 
                                key={index}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Clients;
